import { render } from "./MovementForm.vue?vue&type=template&id=6047eb63&scoped=true"
import script from "./MovementForm.vue?vue&type=script&lang=js"
export * from "./MovementForm.vue?vue&type=script&lang=js"

import "./MovementForm.vue?vue&type=style&index=0&id=6047eb63&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6047eb63"]])

export default __exports__